import { classNames } from '@wix/answers-lib';
import * as React from 'react';
import { RenderHtml } from '../../utils';
export var Icon = function (props) {
    var className = classNames('article-icon-comp', 'icon', props.className, { 'has-color-override': !!props.color });
    var style = props.color && { '--var-color': props.color };
    return (React.createElement("span", { className: className, "aria-hidden": props.ariaHidden, style: style },
        React.createElement(RenderHtml, { html: props.icon, dangerouslyDisableSanitation: props.dangerouslyDisableSanitation })));
};
//# sourceMappingURL=icon.js.map